import React from 'react';

const Send2Icon: React.FC = () => (
  <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.66641 5.26655L13.7414 2.90822C16.9164 1.84988 18.6414 3.58322 17.5914 6.75822L15.2331 13.8332C13.6497 18.5916 11.0497 18.5916 9.46641 13.8332L8.76641 11.7332L6.66641 11.0332C1.90807 9.44988 1.90807 6.85822 6.66641 5.26655Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.9248 11.375L11.9081 8.3833"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Send2Icon;
